export default {
  id: "time-off",
  title: "Time Off Requests",
  section: "Daily Operations",
  order: 24,
  keywords: "time off pto request approve deny unassign shifts vacation partial day review",
  body: `
## What it is

The Time Off page manages caregiver time-off requests end to end: caregivers
request, admins review, and approval automatically clears the caregiver's
schedule for the window. The sidebar's "Time Off (N)" badge is your pending
count.

## How it works

- A request is a **single full day**, a **partial day** (same date with
  start and end times), or a **multi-day span**.
- The list opens filtered to **Pending**; switch status, date range, and —
  for admins — caregiver or manager filters to see history.
- Requests can't overlap: a new request that collides with an existing
  pending or approved one is rejected at creation.
- Approved time off **blocks new scheduling** on those dates, and shows on
  calendars.

### The approval side effect — read this twice

> **Approving a request unassigns the caregiver from every shift that
> overlaps the window.** The shifts remain on the calendar, unassigned,
> waiting to be re-staffed. Partial-day requests only unassign shifts that
> overlap the requested hours. Denying a request changes nothing.

The review modal warns you first: it lists the affected shifts and the
count ("N Shifts Will Be Unassigned") before you click Approve — so you
know the re-staffing work you're taking on.

## Step by step: reviewing a request

1. Open **Time Off** (or click the sidebar badge). Pending requests are
   already on screen.
2. Click **Review** on a request.
3. Read the details and the **unassignment warning** — note which shifts
   will lose their caregiver.
4. Optionally add admin notes, then **Approve** or **Deny**.
5. If you approved: go to the Calendar or Shifts page and **re-staff the
   unassigned shifts** (the count was shown in the review; unassigned
   shifts are easy to spot on the calendar).

## Who can do what

- Admins review requests from the caregivers they manage, and from other
  admins — but **never their own**; a different admin must approve an
  admin's request.
- Caregivers can edit or delete their own request only while it's pending.
- Admins can delete any request.
`,
};
